import React, { useContext, useEffect } from 'react'
import CheckerNotMove from '../cmp/CheckerNotMove'
import Filter from '../cmp/Filter'
//import RangeForm from '../cmp/RangeForm' 
import icon from '../icons.svg'

import { dataContext, localestr, toText, isValidDate, typeToText, strPeriod, exportToExcel } from '../utils.js'

function RepCashflow({ data = undefined, actions }) {
  let wndData = ''
  let content = ''
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const context = useContext(dataContext)
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const loaddat = context.loaddata
  const usersettings = getSettings()
  const msg = context.msg
  const inputRange = context.inputRange
  const OpenTabObject = context.OpenTabObject
  const setPosition = context.setPosition
  const position = context.getPosition('RepCashflow')

  let from = new Date()
  from.setHours(0, 0, 0, 0)
  let to = new Date()
  to.setHours(23, 59, 59, 999)

  let grouping = [{ name: localestr('Каса'), value: 'account_id', checked: true, type: 'catCashAccs' },
  { name: localestr('Стаття'), value: 'article_id', checked: true, type: 'catArticles' },
  { name: localestr('Куди-Звідки'), value: 'from_to', checked: false, type: 'catalog' },
  { name: localestr('Документ'), value: 'doc_id', checked: false, type: 'document' }]


  const filterData = [
    { caption: localestr('Каса'), dataId: 'account_id', typeVal: 'catCashAccs' },
    { caption: localestr('Стаття'), dataId: 'article_id', typeVal: 'catArticles' },
  ]


  if (usersettings) {
    if (usersettings.repCashflow) {
      if (usersettings.repCashflow.from) from = new Date(usersettings.repCashflow.from)
      if (usersettings.repCashflow.to) to = new Date(usersettings.repCashflow.to)
      if (usersettings.repCashflow.grouping) grouping = usersettings.repCashflow.grouping
    }
  }
  if (!grouping.find(el => el.value === 'from_to')) grouping.splice(2, 0, { name: localestr('Куди-Звідки'), value: 'from_to', checked: false, type: 'catalog', disable_move: true })
  if (wndData.grouping) grouping = wndData.grouping
  if (wndData.from) to = wndData.from
  if (wndData.to) to = wndData.to


  function groupingHandler(d) {
    setWndData({ ...wndData, grouping: d })
    setSettings({ repCashflow: { from, to, grouping: d } })
  }

  function filterHandler(d) {
    setWndData({ ...wndData, filter: d })
    //setSettings({repCashflow:{from,to,grouping:d}})
  }

  function range(frm, to_) {
    //let showRange=!wndData.showRange
    let froml = from
    let tol = to
    if (isValidDate(frm)) froml = frm
    if (isValidDate(to_)) tol = to_
    if (froml > tol) {
      msg(localestr('Не правильний діапазон дат'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
      return
    }
    /*let Datal=table
    if (froml!==from || tol!==to) {
        Datal=undefined
    }*/
    /*setWndData({...wndData,showRange,from:froml,to:tol})
    if (!showRange) setSettings({repCashflow:{from:froml,to:tol,grouping}})*/
    setWndData({ ...wndData, from: froml, to: tol })
    setSettings({ repCashflow: { from: froml, to: tol, grouping } })
  }

  function getFolders(d) {
    let ret = ''
    if (!d) return ret
    ret = ",'" + d.id + "'"
    if (d.data) d.data.forEach(el => ret += getFolders(el))
    return ret
  }

  function loadData(d) {
    setPosition('RepCashflow', 0)
    if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      let cols = d.groups.map(el => grouping.find(e => e.value === el))
      cols = cols.filter(el => el !== undefined)
      const filters = d.filters.map(el => el.caption)

      let ttl_sum_s = 0
      let ttl_sum_d = 0
      let ttl_sum_c = 0
      let data = []
      let idx = new Array(cols.length > 1 ? cols.length - 1 : 1)
      let keys = new Array(cols.length > 1 ? cols.length - 1 : 1)
      for (let i = 0; i < d.data.length; i++) {
        if (d.data[i].d_t) d.data[i].date = d.data[i].d_t
        const val = d.data[i]
        if (val['article_n'] === 'ignore') val['article_id'] = undefined
        if (val['cat_n'] === 'ignore') val['cat_id'] = undefined
        let prev = false
        for (let k = 0; k < cols.length - 1; k++) {
          let key_id = cols[k].value
          if (key_id === 'from_to') key_id = 'cat_id'
          if (keys[k] !== val[key_id] || prev) {
            prev = true
            keys[k] = val[key_id]
            //for(let a=k+1;a<keys.length;a++) keys[a]=undefined
            const key = cols[k]
            let obj = null
            const item = { id: val[key.value], type: key.type, name: val[key.value], level: k, keys: keys.filter((e, id) => id < k), sum_s: parseFloat(val.sum_s || 0), sum_d: parseFloat(val.sum_d || 0), sum_c: parseFloat(val.sum_c || 0) }
            if (key.type === 'catalog') { item.name = val['cat_n'] || '---'; item.type = val['cat_t']; item.type2 = 'catalog' }
            else if (key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'fld') item.name = val[key.value.substring(0, key.value.length - 2) + 'n'] || localestr('(пусто)')
            if (key.type.substring(0, 3) === 'doc' && val['doc_type']) item.name = localestr('Поступлення') + ' №' + val[key.value] + (val['doc_n'] ? ' ' + val['doc_n'] : '') + ' (' + new Date(val[key.value.substring(0, key.value.length - 2) + 'd']).toLocaleString() + ')'
            if (key.type.substring(0, 3) === 'sel') item.name = context.data[key.type].find(e => e.value === val[key.value]).name
            if (key.type.substring(0, 3) === 'doc' && item.id && val['doc_type']) obj = { type: val['doc_type'], id: item.id }
            else if (key.type === 'catalog' && val.id) obj = { type: val['cat_t'], id: item.id }
            else if ((key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'doc') && item.id) obj = { type: key.type, id: item.id }
            if (item.id === '000000') item.type = 'text'
            if (item.name === 'text') item.name = localestr('Залишок')
            item.obj = obj
            idx[k] = data.length
            data.push(item)
            if (item.type === 'catArticles' && val['article_n'] !== 'ignore') continue
            else if (item.type2 === 'catalog' && val['cat_n'] !== 'ignore' && item.type2 === 'catalog' && val['cat_n'] !== 'text') continue
            if (item.name === 'no_sum') continue
            if (item.level) continue
            //console.log(item)
            ttl_sum_s += item.sum_s
            ttl_sum_d += item.sum_d
            ttl_sum_c += item.sum_c
          }
        }
        const key = cols[cols.length - 1]
        let obj = null
        const item = { id: val[key.value], type: key.type, type2: null, name: val[key.value], level: cols.length - 1, keys: [...keys], sum_s: parseFloat(val.sum_s || 0), sum_d: parseFloat(val.sum_d || 0), sum_c: parseFloat(val.sum_c || 0) }
        if (key.type === 'catalog') { item.name = val['cat_n'] || '---'; item.type = val['cat_t']; item.type = val['qtt_s'] = 0; item.type2 = 'catalog' }
        else if (key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'fld') item.name = val[key.value.substring(0, key.value.length - 2) + 'n'] || localestr('(пусто)')
        if (key.type.substring(0, 3) === 'doc' && val['doc_t'] === 'ignore') { item.name = 'ignore' }
        else if (key.type.substring(0, 3) === 'doc' && val['doc_t'] === 'no_sum') { item.name = 'no_sum' }
        else if (key.type.substring(0, 3) === 'doc' && val['doc_t'] === 'text') { item.name = localestr('Залишок') + ' (' + new Date(val[key.value.substring(0, key.value.length - 2) + 'd']).toLocaleString() + ')'; item.type = 'text' }
        else if (key.type.substring(0, 3) === 'doc') item.name = typeToText(val['doc_t']) + ' №' + val[key.value] + (val['doc_n'] ? ' ' + val['doc_n'] : '') + ' (' + new Date(val[key.value.substring(0, key.value.length - 2) + 'd']).toLocaleString() + ')'
        if (key.type.substring(0, 3) === 'sel') item.name = context.data[key.type].find(e => e.value === val[key.value]).name
        if (key.type.substring(0, 3) === 'doc' && val['doc_t'] !== 'text' && val['doc_t'] !== 'ignore') obj = { type: val['doc_t'], id: item.id }
        else if (key.type === 'catalog') if (val['cat_id'] !== '000000') obj = { type: val['cat_t'], id: val['cat_id'] }
        else if ((key.type.substring(0, 3) === 'cat' || key.type.substring(0, 3) === 'doc') && val['doc_t'] !== 'text' && val['doc_t'] !== 'ignore' && item.id) obj = { type: key.type, id: item.id }
        if (item.id === '000000') item.type = 'text'
        if (item.name === 'text') item.name = localestr('Залишок')
        item.obj = obj
        //data.push(item)
        if (item.name !== 'ignore' && item.name !== 'no_sum') data.push(item)
        /*if(key.type.substring(0,3)==='doc'&&val['doc_t']!=='text'&&val['doc_t']!=='ignore'&&val['doc_t']!=='no_sum') continue*/
        if (item.type === 'catArticles' && val['article_n'] !== 'ignore') continue
        else if (item.type2 === 'catalog' && val['cat_n'] !== 'ignore' && item.type2 === 'catalog' && val['cat_n'] !== 'text') continue
        /*for(let k=0;k<cols.length-1;k++){
            if(data[idx[k]].level<item.level-1&&item.name==='no_sum') continue
            //if(val['article_n']!=='ignore'&&val['cat_n']==='ignore') continue
            data[idx[k]].sum_s+=item.sum_s
            if(key.type.substring(0,3)!=='doc'&&val['cat_n']==='ignore') continue
            data[idx[k]].sum_d+=item.sum_d
            data[idx[k]].sum_c+=item.sum_c
        }*/
        if (item.name === 'no_sum') continue
        if (item.level) continue
        if (item.type === 'document') continue
        console.log(item)
        ttl_sum_s += item.sum_s
        ttl_sum_d += item.sum_d
        ttl_sum_c += item.sum_c
      }
      const item = { id: 'totals', type: 'totals', name: localestr('Разом'), level: -1, keys: [], sum_s: ttl_sum_s, sum_d: ttl_sum_d, sum_c: ttl_sum_c }
      data.push(item)
      data = data.filter(el => el.name !== 'ignore')
      const caption = localestr('Звіт про рух коштів за період ') + new Date(d.from).toLocaleDateString() + ' - ' + new Date(d.to).toLocaleDateString() + ''
      let headcol = ''
      cols.forEach(el => headcol += '/' + el.name)
      headcol = headcol.substring(1)
      setWndData({ ...wndData, content: { caption, headcol, filters, data } })

    } else {
      let groups = []
      let froml = from.toISOString().substring(0, 19) + 'Z'
      let tol = to.toISOString().substring(0, 19) + 'Z'
      let tz = to.getTimezoneOffset()
      if (tz < 0) tz = '%2B0' + (tz / -60) + ':00'
      else tz = '-0' + (tz / 60) + ':00'
      for (let i = 0; i < grouping.length; i++) if (grouping[i].checked) groups.push(grouping[i].value)
      if (groups.length === 0) {
        msg(localestr('Треба вибрати хоча б одне групування'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
        return
      }
      let filters = []
      if (wndData.filter) {
        filters = wndData.filter.filter(el => el.compare)
        for (let i = 0; i < filters.length; i++) {
          let new_el = { value: filters[i].dataId }
          if (filters[i].compare === '=' || filters[i].compare === '>' || filters[i].compare === '<') {
            if (!filters[i].value) new_el.compare = ' IS NULL'
            else if (filters[i].value.id) new_el.compare = '' + filters[i].compare + "'" + filters[i].value.id + "'"
            else new_el.compare = '' + filters[i].compare + "'" + filters[i].value + "'"
            new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + toText(filters[i].value)
          } if (filters[i].compare === '<>') {
            if (!filters[i].value) new_el.compare = ' IS NOT NULL'
            else if (filters[i].value.id) new_el.compare = "!='" + filters[i].value.id + "'"
            else new_el.compare = '' + filters[i].compare + "'" + filters[i].value + "'"
            new_el.caption = filters[i].caption + ' ' + filters[i].compare + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'lk') {
            new_el.compare = "LIKE('%" + filters[i].value + "%')"
            new_el.caption = filters[i].caption + ' ' + localestr('містить') + ' ' + toText(filters[i].value)
          }
          else if (filters[i].compare === 'nlk') {
            new_el.compare = "NOT LIKE('%" + filters[i].value + "%')"
            new_el.caption = filters[i].caption + ' ' + localestr('не містить') + ' ' + toText(filters[i].value)
          }
          else if (filters[i].compare === 'in_f') {
            new_el.value = filters[i].dataId + 'p'
            new_el.compare = 'IN(' + getFolders(filters[i].value).substring(1) + ')'
            new_el.caption = filters[i].caption + ' ' + localestr('в папці') + ' ' + toText(filters[i].value)
          } else if (filters[i].compare === 'nin_f') {
            new_el.value = filters[i].dataId + 'p'
            new_el.compare = 'NOT IN(' + getFolders(filters[i].value).substring(1) + ')'
            new_el.caption = filters[i].caption + ' ' + localestr('не в папці') + ' ' + toText(filters[i].value)
          }
          filters[i] = new_el
        }
      }
      loaddat('action=repCashflow&data=' + JSON.stringify({ from: froml, to: tol, tz, groups, filters }), null, (dt) => { loadData(dt) })
    }
  }

  function specification(obj) {
    if (!obj) return
    //console.log(obj)
    OpenTabObject(obj.type, obj.id)
  }

  if (wndData.content) {
    let filters = null
    if (wndData.content.filters.length) {
      filters = wndData.content.filters.map((el, idx) => {
        return <p key={idx}>{el}</p>
      })
      filters = <div className='rep_filters'>{filters}</div>
    }
    //console.log(wndData.content.data)
    const items = wndData.content.data.map((el, idx) => {
      const sum_s = el.sum_s ? el.sum_s.toFixed(2) : ''
      const sum_d = el.sum_d ? el.sum_d.toFixed(2) : ''
      const sum_c = el.sum_c ? el.sum_c.toFixed(2) : ''
      let sum_f = (el.sum_s + el.sum_d - el.sum_c) ? (el.sum_s + el.sum_d - el.sum_c).toFixed(2) : ''
      if (el.type === 'document' || el.type === 'catArticles' || el.type2 === 'catalog') sum_f = ''
      if (el.obj) return <tr tabIndex='0' key={idx}><td style={{ cursor: 'pointer' }} className={'rep_grp' + el.level} onDoubleClick={() => specification(el.obj)}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.sum_s < 0 ? ' red' : '')}>{sum_s}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.sum_d < 0 ? ' red' : '')}>{sum_d}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.sum_c < 0 ? ' red' : '')}>{sum_c}</td><td className={'rep_grp' + el.level + ' rep_number' + (sum_f < 0 ? ' red' : '')}>{sum_f}</td></tr>
      else return <tr tabIndex='0' key={idx}><td className={'rep_grp' + el.level}>{el.name}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.sum_s < 0 ? ' red' : '')}>{sum_s}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.sum_d < 0 ? ' red' : '')}>{sum_d}</td><td className={'rep_grp' + el.level + ' rep_number' + (el.sum_c < 0 ? ' red' : '')}>{sum_c}</td><td className={'rep_grp' + el.level + ' rep_number' + (sum_f < 0 ? ' red' : '')}>{sum_f}</td></tr>
    })
    content = <><h3 className='rep_caption'>{wndData.content.caption}</h3>{filters}
      <table className='rep_table'>
        <thead><tr><th>{wndData.content.headcol}</th><th>{localestr('Залишок на початок')}</th><th>{localestr('Прихід')}</th><th>{localestr('Розхід')}</th><th>{localestr('Залишок на кінець')}</th></tr></thead>
        <tbody>{items}</tbody>
      </table>
    </>
  }

  const setPos = target => {
    if (!target) return
    //if(!position) return
    target.scrollTop = position
  }

  //const showRange = wndData.showRange ? <RangeForm from={from} to={to} setRng={range}/> : ''  //+
  let btn2 = null
  if (content) {
    btn2 = <div className='no-print' style={{ position: 'absolute', top: '5px', right: '5px', display: 'flex', gap: '5px' }}>
      <div onClick={e => window.print()} style={{ cursor: 'pointer', }}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#b503'} alt='' />
      </div>
      <div style={{ cursor: 'pointer', }} onClick={() => exportToExcel(wndData)}>
        <img style={{ width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
      </div>

    </div>
  }

  useEffect(() => {
    if (wndData && wndData.run) setTimeout(loadData, 200)
    // eslint-disable-next-line 
  }, [])

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className='toolBar no-print'>
          <div tabIndex='0' onClick={() => { loadData() }} onKeyUp={(e) => { if (e.key === 'Enter') loadData() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '12px', height: '24px', padding: '2px', verticalAlign: 'middle' }} src={icon + '#run'} alt={localestr('Вивести')} />&nbsp;
            {localestr('Вивести')}
          </div>
          <div tabIndex='0' onClick={() => { inputRange(from, to, range) }} onKeyUp={(e) => { if (e.key === 'Enter') range() }}
            style={{ textAlign: 'center', lineHeight: '30px', height: '30px', width: '192px', padding: '0px 20px 0 2px', userSelect: 'none', cursor: 'pointer', color: '#FFF', background: 'url(' + icon + '#btn185v) no-repeat', backgroundSize: '192px 30px', boxSizing: 'border-box', position: 'relative', wordBreak: 'break-all' }}>
            {strPeriod(from, to)}
            <img style={{ width: '24px', height: '24px', position: 'absolute', top: '5px', right: '4px' }} src={icon + '#cal_w'} alt={localestr('Інтервал дат')} />
          </div>
          <div style={{ flexGrow: '10' }}></div>
        </div>
        <div className='reportContent' style={{ position: 'relative' }} ref={el => { setPos(el) }} onScroll={e => setPosition('RepCashflow', e.target.scrollTop)}>{content}{btn2}</div>
      </div>
      <div className='reportTuns no-print'>
        <CheckerNotMove caption={localestr('Групування')} data={grouping} setData={groupingHandler} />
        <Filter filterData={filterData} filter={wndData.filter} setFilter={filterHandler} />
      </div>
      {/*showRange*/}
    </div>
  )

}


export default RepCashflow